<template>
  <div :asset-name="slug">
    <section class="signup-success">
      <div
        :class="{
          'container mx-auto my-6': true,
        }"
      >
        <component
          :is="getComponent(props._type)"
          :value="props"
          :class="{
            'my-6': true,
          }"
        />
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { getComponent } from '~/components/Mapper';
import type { UssSuccessRedirect } from '~/sanity/types';

const props = defineProps<UssSuccessRedirect>();

const { slug } = useRoute().params;
</script>
<style lang="scss" scoped></style>
